import moment, { Moment } from 'moment'
import React, { PropsWithChildren } from 'react'

type TFormat = 'long' | 'short' | 'extra-short' | 'medium' | 'full'

interface IProps {
  format: TFormat
  date: Moment
}

export const DateText = ({ format, date }: IProps) => {
  let momentFormat
  switch (format) {
    case 'extra-short':
      momentFormat = 'dd Do'
      break
    case 'short':
      momentFormat = 'DD/MM/YYYY'
      break
    case 'medium':
      momentFormat = 'D MMM YYYY'
      break
    case 'long':
      momentFormat = 'D MMMM YYYY'
      break
    case 'full':
    default:
      momentFormat = 'dddd D MMMM YYYY'
      break
  }

  if (!moment.isMoment(date)) {
    return <>{date}</>
  }

  return <>{date.format(momentFormat)}</>
}
